export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/d3-scale/src/constant.js
// module id = 675
// module chunks = 0